import { render, staticRenderFns } from "./WebhooksConfiguracao.vue?vue&type=template&id=f525591c&"
import script from "./WebhooksConfiguracao.vue?vue&type=script&lang=js&"
export * from "./WebhooksConfiguracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports